import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout, userType }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const creatorLinks = [
    { path: '/creator/dashboard', label: 'Dashboard' },
    { path: '/creator/portfolio', label: 'Portfolio' },
    { path: '/creator/import', label: 'Import' },
    { path: '/creator/curation', label: 'Curation' }
  ];

  const recruiterLinks = [
    { path: '/recruiter/dashboard', label: 'Dashboard' },
    { path: '/recruiter/search', label: 'Talent Search' },
    { path: '/recruiter/pipeline', label: 'Pipeline' }
  ];

  const links = userType === 'creator' ? creatorLinks : recruiterLinks;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to={`/${userType}/dashboard`}>
            <h1>⚡ Fashion Portfolios</h1>
          </Link>
        </div>

        <div className="navbar-links">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`navbar-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="navbar-user">
          <span className="user-name">{user.name}</span>
          <button onClick={onLogout} className="btn btn-secondary btn-sm">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
